import { createContext, useContext } from 'react';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';

export const LanguagePairContext = createContext<DetailedSourceLanguageResponse | null>(null);

export const useLanguagePairContext = () => {
  const languagePairContext = useContext(LanguagePairContext);
  if (languagePairContext) return languagePairContext;
  throw new Error('LanguagePairContext must be used only inside LanguagePairProvider');
};
